
export function removeOldWeeks()
{
	if( $('#dateSelect').length !== 0 )
	{
		var options = $('#dateSelect option');
		var twoDaysAgo = Date.now() - ( 1000 * 60 * 60 * 24 * 2 );
		var searchParams = searchParameters.getParameters();
		for( var i = 0; i < options.length; i++ )
		{
			var dateRaw = $(options[i]).val();
			if( dateRaw !== 'none' )
			{
				var date = new Date(dateRaw+" 00:00:00");
				if( date < twoDaysAgo )
				{
					$(options[i]).remove();
					if( typeof searchParams.ankomst !== 'undefined' && searchParams.ankomst === dateRaw )
					{
						searchParameters.removeParameter('ankomst')
						$('#dateSelect').val('none');
					}
				}
			}
		}
	}
}
